import { useState, useEffect, useRef } from "react";
import "./Services.css";
import ReactDOM from "react-dom";

import crescentVille from "../../assets/projectsimgs/crescentVille.png";
import llcdorm from "../../assets/projectsimgs/llcdorm.png";
import llcAdmin from "../../assets/projectsimgs/llcAdmin.png";
import llcNursing from "../../assets/projectsimgs/llcNursing.png";
import jglTower from "../../assets/projectsimgs/jglTower.png";
import unifiInstallation from "../../assets/projectsimgs/unifiInstallation.png";
import nitoTower from "../../assets/projectsimgs/1nitoTower.png";

import crescentVilles from "../../assets/projectsimgs/crescentVilles.png";
import crescentVille2 from "../../assets/projectsimgs/crescentVille4.png";
import crescentVille3 from "../../assets/projectsimgs/crescentVille1.png";
import crescentVille4 from "../../assets/projectsimgs/crescentVille2.png";
import crescentVille5 from "../../assets/projectsimgs/crescentVille3.png";
import crescentVille6 from "../../assets/projectsimgs/crescentVille5.png";

import llcdorm1 from "../../assets/projectsimgs/llcdorm4.png";
import llcdorm2 from "../../assets/projectsimgs/llcdorm5.png";
import llcdorm3 from "../../assets/projectsimgs/llcdorm2.png";
import llcdorm4 from "../../assets/projectsimgs/llcdorm1.png";
import llcdorm5 from "../../assets/projectsimgs/llcdorm3.png";

import llcAdmin1 from "../../assets/projectsimgs/llcAdmin1.png";
import llcAdmin2 from "../../assets/projectsimgs/llcAdmin2.png";
import llcAdmin3 from "../../assets/projectsimgs/llcAdmin3.png";
import llcAdmin4 from "../../assets/projectsimgs/llcAdmin4.png";
import llcAdmin5 from "../../assets/projectsimgs/llcAdmin5.png";

import llcNursing1 from "../../assets/projectsimgs/llcNursing1.png";
import llcNursing2 from "../../assets/projectsimgs/llcNursing5.png";
import llcNursing3 from "../../assets/projectsimgs/llcNursing2.png";
import llcNursing4 from "../../assets/projectsimgs/llcNursing3.png";
import llcNursing5 from "../../assets/projectsimgs/llcNursing4.png";

import jglTower1 from "../../assets/projectsimgs/jglTower1.png";
import jglTower2 from "../../assets/projectsimgs/jglTower2.png";
import jglTower3 from "../../assets/projectsimgs/jglTower3.png";
import jglTower4 from "../../assets/projectsimgs/jglTower4.png";
import jglTower5 from "../../assets/projectsimgs/jglTower5.png";

import unifiInstallation1 from "../../assets/projectsimgs/unifiInstallation1.png";
import unifiInstallation2 from "../../assets/projectsimgs/unifiInstallation3.png";
import unifiInstallation3 from "../../assets/projectsimgs/unifiInstallation2.png";
import unifiInstallation4 from "../../assets/projectsimgs/unifiInstallation4.png";
import unifiInstallation5 from "../../assets/projectsimgs/unifiInstallation1.png";

import nitoTower1 from "../../assets/projectsimgs/1nitoTower1.png";
import nitoTower2 from "../../assets/projectsimgs/1nitoTower4.png";
import nitoTower3 from "../../assets/projectsimgs/1nitoTower2.png";
import nitoTower4 from "../../assets/projectsimgs/1nitoTower3.png";
import nitoTower5 from "../../assets/projectsimgs/1nitoTower1.png";

import ViewWork from "./ViewWork";

const servicesData = [
  {
    title: "Hotel One",
    cover: unifiInstallation,
    tag: "Network Infrastructure",
    images: [unifiInstallation1, unifiInstallation2, unifiInstallation3, unifiInstallation4, unifiInstallation5],
    description: "Unifi Ubiquiti Booster Installation to enhance safety and high-security services.",
  },
  {
    title: "JGL Tower",
    cover: jglTower,
    tag: "Structured Cabling",
    images: [jglTower1, jglTower2, jglTower3, jglTower4, jglTower5],
    description: "Structured Cabling and Installation of Devices — CCTV Cameras, Smoke Detectors and other systems at JGL Tower, Bacolod City, Negros Occidental.",
  },
  {
    title: "Crescent VILLE Minglanilla",
    cover: crescentVille,
    tag: "CCTV Systems",
    images: [crescentVilles, crescentVille2, crescentVille3, crescentVille4, crescentVille5, crescentVille6],
    description: "Completed CCTV Camera Installation at Crescent VILLE Minglanilla — 7 units ColorVu Outdoor Bullet Type Camera, DVR, HDD, LED Monitor, and UPS.",
  },
  {
    title: "1Nito Tower",
    cover: nitoTower,
    tag: "Wireless Access Points",
    images: [nitoTower1, nitoTower2, nitoTower3, nitoTower4, nitoTower5],
    description: "Structured Cabling and Installation of Wireless Access Points at 1Nito Tower, Archbishop Reyes Ave, Cebu City.",
  },
  {
    title: "CIC Dormitory Building",
    cover: llcdorm,
    tag: "Structured Cabling",
    images: [llcdorm1, llcdorm2, llcdorm3, llcdorm4, llcdorm5],
    description: "Structured Cabling and Installation of CCTV Cameras, Smoke Detectors and other systems at the Dormitory Building, Lapu-Lapu City.",
  },
  {
    title: "CIC Admin Building",
    cover: llcAdmin,
    tag: "Systems Integration",
    images: [llcAdmin1, llcAdmin2, llcAdmin3, llcAdmin4, llcAdmin5],
    description: "Structured Cabling and Installation of CCTV Cameras, Smoke Detectors and other systems at the Admin Building, Lapu-Lapu City.",
  },
  {
    title: "CIC Nursing Building",
    cover: llcNursing,
    tag: "Systems Integration",
    images: [llcNursing1, llcNursing2, llcNursing3, llcNursing4, llcNursing5],
    description: "Structured Cabling and Installation of CCTV Cameras, Smoke Detectors and other systems at the Nursing Building, Lapu-Lapu City.",
  },
];

function Services() {
  const [selectedService, setSelectedService] = useState(null);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section id="projects" ref={sectionRef} className={`sv-root ${visible ? "sv-visible" : ""}`}>

        {/* ── Header ── */}
        <div className="sv-header">
          <p className="sv-eyebrow">Our work</p>
          <h2 className="sv-headline">Featured Projects</h2>
        </div>

        {/* ── Grid ── */}
        <div className="sv-grid">

          {/* Row 1 — hero card + tall card */}
          <div
            className="sv-card sv-card--hero"
            style={{ backgroundImage: `url(${servicesData[0].cover})` }}
            onClick={() => setSelectedService(servicesData[0])}
          >
            <div className="sv-card-info">
              <span className="sv-card-tag">{servicesData[0].tag}</span>
              <p className="sv-card-title">{servicesData[0].title}</p>
            </div>
          </div>

          <div
            className="sv-card sv-card--tall"
            style={{ backgroundImage: `url(${servicesData[1].cover})` }}
            onClick={() => setSelectedService(servicesData[1])}
          >
            <div className="sv-card-info">
              <span className="sv-card-tag">{servicesData[1].tag}</span>
              <p className="sv-card-title">{servicesData[1].title}</p>
            </div>
          </div>

          {/* Row 2 — three equal cards */}
          {servicesData.slice(2, 5).map((s, i) => (
            <div
              key={i}
              className="sv-card sv-card--md"
              style={{ backgroundImage: `url(${s.cover})` }}
              onClick={() => setSelectedService(s)}
            >
              <div className="sv-card-info">
                <span className="sv-card-tag">{s.tag}</span>
                <p className="sv-card-title">{s.title}</p>
              </div>
            </div>
          ))}

          {/* Row 3 — two remaining + empty filler */}
          {servicesData.slice(5).map((s, i) => (
            <div
              key={i}
              className="sv-card sv-card--md"
              style={{ backgroundImage: `url(${s.cover})` }}
              onClick={() => setSelectedService(s)}
            >
              <div className="sv-card-info">
                <span className="sv-card-tag">{s.tag}</span>
                <p className="sv-card-title">{s.title}</p>
              </div>
            </div>
          ))}

        </div>

      </section>

      {selectedService &&
        ReactDOM.createPortal(
          <ViewWork
            service={selectedService}
            onBack={() => setSelectedService(null)}
          />,
          document.body
        )}
    </>
  );
}

export default Services;